import ClinicPicker from "@components/layout/ClinicPicker";

/** Keys are what the pages route on; labels are what the clinic reads. */
export const FRONTDESK_TABS = [
  ["calls", "Frontdesk Calls"],
  ["reactivation", "Reactivation"],
  ["control", "Control Panel"],
];

// Reactivation gets the teal accent: it is the outbound side of the desk.
// Calls and Control Panel keep the neutral one.
const ACCENT = {
  reactivation: "border-teal-600 text-teal-700",
};

/**
 * The frontdesk surface's tab row, shared by /voice and /reactivation so a
 * voice clinic sees one surface: Frontdesk Calls, Reactivation, Control
 * Panel. The page decides what a click means (switch a local view or
 * navigate); this only knows which tab is lit and which are offered.
 *
 * An admin's clinic picker sits at the right end of the row, so the clinic
 * is chosen where the surface is identified. `clinicFilter` lets a page
 * narrow the clinics it can show (reactivation needs a scheduling system).
 */
export default function FrontdeskTabs({
  active, showReactivation = true, onSelect, clinicFilter,
}) {
  const tabs = FRONTDESK_TABS.filter(([key]) => key !== "reactivation" || showReactivation);
  return (
    <div className="flex items-center gap-1 border-b border-gray-200 sticky top-0 z-10 bg-white px-6 pt-4">
      {tabs.map(([key, label]) => (
        <button
          key={key}
          type="button"
          onClick={() => onSelect(key)}
          aria-current={active === key ? "page" : undefined}
          className={`-mb-px px-4 py-2.5 text-sm font-semibold border-b-2 transition-colors duration-150 ${
            active === key
              ? ACCENT[key] || "border-gray-900 text-gray-900"
              : "border-transparent text-gray-500 hover:text-gray-700"
          }`}
        >
          {label}
        </button>
      ))}
      <ClinicPicker filter={clinicFilter} className="ml-auto mb-2" />
    </div>
  );
}
